import { render, staticRenderFns } from "./newsArticle.vue?vue&type=template&id=7275171b&"
import script from "./newsArticle.vue?vue&type=script&lang=js&"
export * from "./newsArticle.vue?vue&type=script&lang=js&"
import style0 from "./newsArticle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports